import { Button, Flex, Text } from '@mantine/core';
import React, { useState, useRef, useEffect } from 'react';

export const ExpandableValue = ({ text }: { text: string }) => {
  const [expanded, setExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const overflowing = el.scrollHeight > el.clientHeight + 1;
      setIsOverflowing(overflowing);
    }
  }, [text]);

  return (
    <Flex align="end" justify="space-between" gap={10}>
      <Text
        ref={textRef}
        style={{
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 'unset' : 2,
          WebkitBoxOrient: 'vertical',
          flex: 1,
          fontSize: 14
        }}>
        {text}
      </Text>

      {isOverflowing && (
        <Button
          variant="subtle"
          size="xs"
          c="dpkk-blue"
          px={4}
          onClick={() => setExpanded(!expanded)}>
          {expanded ? '<<' : '>>'}
        </Button>
      )}
    </Flex>
  );
};
